import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'api';
import { updateAnswer } from '../methods';
import { UpdateAnswerRequest, UpdateAnswerResponse } from '../types';

export const useUpdateAnswer = (
  answerUpdated: () => void
): UseMutationResult<UpdateAnswerResponse, unknown, UpdateAnswerRequest> => {
  const queryClient = useQueryClient();
  return useMutation(updateAnswer, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getConsultation] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getCaseDetails] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getResponses] });
      answerUpdated();
    },
  });
};
